import React from "react";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Circle,
  G,
  ClipPath,
  Rect
} from "react-native-svg";

export default function SendCommentIcon({ width = 25, height = 26 }) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#clip0_12995_91744)">
        <Circle
          cx="12.9728"
          cy="13.0001"
          r="12.0148"
          fill="url(#paint0_linear_12995_91744)"
        />
        <Path
          d="M7.9726 18.7212L20.1484 13.5005L7.9726 8.27979L7.9668 12.3403L16.668 13.5005L7.9668 14.6606L7.9726 18.7212Z"
          fill="white"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_12995_91744"
          x1="0.958007"
          y1="6.19658"
          x2="12.5252"
          y2="29.8319"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
        <ClipPath id="clip0_12995_91744">
          <Rect
            width="24.0296"
            height="24.0296"
            fill="white"
            transform="translate(0.958008 0.985352)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
